import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/invalid-link")({
  staticData: { title: "Invalid Link" },
  component: lazyRouteComponent(
    () => import("#pages/login/invalid-link.tsx"),
    "LinkInvalid",
  ),
})
